import { render } from "./SmartZoneIcon.vue?vue&type=template&id=452856b7&lang=html"
import script from "./SmartZoneIcon.vue?vue&type=script&lang=js"
export * from "./SmartZoneIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__